import React from "react";
import { useTranslation } from "react-i18next";
import { WellbeingSpark as SharedWellbeingSpark } from "@sophy/shared-ui";

const MAX_POINTS = 12;

/** The shared curve with this app's labels; `points` come from wellbeing(). */
export function WellbeingSpark({ points = [], showEnds = true }) {
  const { t, i18n } = useTranslation();
  const shown = points.slice(-MAX_POINTS);
  const first = shown[0];

  return (
    <SharedWellbeingSpark
      points={points}
      emptyLabel={t("gamification.wellbeing.too_few")}
      startLabel={
        showEnds && first?.date ? first.date.toLocaleDateString(i18n.language, { day: "numeric", month: "long" }) : ""
      }
      endLabel={showEnds ? t("gamification.wellbeing.last", { count: shown.length }) : ""}
      ariaLabel={t("gamification.wellbeing.title")}
    />
  );
}

export default WellbeingSpark;
